import { mapState } from "vuex";
import { findUserFuncInfo } from "@/api";

export const groupPurchaseIndexMixins = {
  data() {
    return {
      isHavAIwrite: false,
      isHavAIdraw: false,
      isHavMatrixCode: false,
      isHavPyp: false,
    };
  },
  computed: {
    ...mapState({
      shopInfo: (state) => state.shopInfo,
      isOwn: (state) => state.isOwn,
      oemInfo: (state) => state.oemInfo,
    }),
    groupPurchaseTopBarList() {
      let topbarList = [
        {
          name: "拼团管理",
          isActive: false,
          path: "/groupPurchase",
          icon:require("@/assets/img/menuIcons/icon-groupPurchase.png")
        },
        {
          name: "本地生活团购拼团管理",
          isActive: false,
          path: "/BDSHGroupPurchase",
          icon:require("@/assets/img/menuIcons/icon-groupPurchase.png")
        },
        {
          name: "砍价管理",
          isActive: false,
          path: "/bargin",
          icon:require("@/assets/img/menuIcons/icon-bargin.png")
        },
        {
          name: "积分兑换",
          isActive: false,
          path: "/exchange",
          icon:require("@/assets/img/menuIcons/icon-exchange.png")
        },
      ];
      if (this.shopInfo.edcShopType == 5) {
        topbarList = [
          {
            name: "积分兑换",
            isActive: false,
            path: "/exchange",
            icon:require("@/assets/img/menuIcons/icon-exchange.png")
          },
        ];
      }
      if (this.isOwn) {
        topbarList.push({
          name: "云推码",
          isActive: false,
          path: "/marketingActivity",
          icon:require("@/assets/img/menuIcons/icon-marketingActivity.png")
        });
      } else {
        console.log(this.oemInfo);
        if (this.oemInfo && this.oemInfo.isOpenBdmOem) {
          topbarList.push({
            name: "云推码",
            isActive: false,
            path: "/marketingActivity",
            icon:require("@/assets/img/menuIcons/icon-marketingActivity.png")
          });
        }
      }
      if (this.isHavAIdraw) {
        topbarList.push({
          name: "AI绘画",
          isActive: false,
          path: "/AIdraw",
          icon:require("@/assets/img/menuIcons/icon-AIdraw.png")
        });
      }
      if (this.isHavAIwrite) {
        topbarList.push({
          name: "AI文案",
          isActive: false,
          path: "/AIcopywriting",
          icon:require("@/assets/img/menuIcons/icon-AIcopywriting.png")
        });
      }
      if (this.isHavMatrixCode) {
        topbarList.push({
          name: "矩阵码",
          isActive: false,
          path: "/matrixCode",
          icon:require("@/assets/img/menuIcons/icon-matrixCode.png")
        });
      }
      topbarList.push({
        name: "矩阵资源",
        isActive: false,
        path: "/matrixCodeResource",
        icon:require("@/assets/img/menuIcons/icon-matrixCodeResource.png")
      });
      topbarList.push({
        name: "幸运抽奖",
        isActive: false,
        path: "/luckyLottery",
        icon:require("@/assets/img/menuIcons/icon-luckyLottery.png")
      });
      topbarList.push({
        name: "碰一碰引流卡",
        isActive: false,
        path: "/touchDrainageCard",
        icon:require("@/assets/img/menuIcons/icon-touchDrainageCard.png")
      });
      // if (this.isOwn) {
      topbarList.push({
        name: "支付后配置",
        isActive: false,
        path: "/configurationAfterPayment",
        icon:require("@/assets/img/menuIcons/icon-configurationAfterPayment.png")
      });
      // }
      topbarList.push({
        name: "视频号活动",
        isActive: false,
        path: "/videoAccountActivities",
        icon:require("@/assets/img/menuIcons/icon-videoAccountActivities.png")
      });
      topbarList.push({
        name: "会员生日活动",
        isActive: false,
        path: "/vipBirthdayActivity",
        icon:require("@/assets/img/menuIcons/icon-vipBirthdayActivity.png")
      });
      topbarList.push({
        name: "新注册会员活动",
        isActive: false,
        path: "/newRegisterVIPActivity",
        icon:require("@/assets/img/menuIcons/icon-vipBirthdayActivity.png")
      });
      if (this.isHavPyp) {
        topbarList.push({
          name: "碰一碰引流卡2.0",
          isActive: false,
          path: "/touchDrainageCardNew",
          icon:require("@/assets/img/menuIcons/icon-touchDrainageCard.png")
        });
      }
      topbarList.forEach((val) => {
        if (val.path == this.$route.path) {
          val.isActive = true;
        }
      });
      return topbarList;
    },
  },
  mounted() {
    findUserFuncInfo({
      userFuncType: 16,
    }).then((res) => {
      if (res.code == 1) {
        if (res.data.userFuncStatus == 20 || res.data.userFuncStatus == 30) {
          this.isHavAIwrite = true;
        }
      }
    });
    findUserFuncInfo({
      userFuncType: 17,
    }).then((res) => {
      if (res.code == 1) {
        if (res.data.userFuncStatus == 20 || res.data.userFuncStatus == 30) {
          this.isHavAIdraw = true;
        }
      }
    });
    findUserFuncInfo({
      userFuncType: 18,
    }).then((res) => {
      if (res.code == 1) {
        if (res.data.userFuncStatus == 20 || res.data.userFuncStatus == 30) {
          this.isHavMatrixCode = true;
        }
      }
    });
    findUserFuncInfo({
      userFuncType: 19,
    }).then((res) => {
      if (res.code == 1) {
        if (res.data.userFuncStatus == 20 || res.data.userFuncStatus == 30) {
          this.isHavPyp = true;
        }
      }
    });
  },
}
